import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';
import { observer } from 'mobx-react';

import { Link } from 'core/routing';
import MobileUserNav from 'apps/components/header/blocks/mobileUserNav';

import {
  UserNavItem,
  ProfileAvatar,
  Dropdown,
  DropdownItem,
  DropdownTitle,
  DropdownSeparator,
} from 'apps/components/header/header.styled';

const HeaderAvatar = observer(props => {
  const { isMobile, headerStore, clientStore } = props;
  const { username, content } = clientStore?.signedInProfile;

  const closeAllMenus = () => {
    headerStore.CloseAllMenus();
  };

  const onClickSignOut = () => {
    closeAllMenus();
    clientStore.SignOutUser();
  };

  const headerAvatarMenuConfig = {
    title: username,
    list: [
      {
        node: (
          <Link name='profile' params={{ profile: username }} content={content}>
            <Trans>My Profile</Trans>
          </Link>
        ),
        onClick: closeAllMenus,
      },
      {
        node: (
          <Link name='home.pricing'>
            <Trans>Upgrade account</Trans>
          </Link>
        ),
        onClick: closeAllMenus,
      },
      {
        node: (
          <Link
            name='workspace.spaceSettings.account'
            params={{ spacePath: username }}
            content={content}
          >
            <Trans>Settings</Trans>
          </Link>
        ),
        onClick: closeAllMenus,
      },
      {
        node: (
          <Link name='profile.invitations' params={{ profile: username }}>
            <Trans>Invite friends</Trans>
          </Link>
        ),
        onClick: closeAllMenus,
      },
      {
        danger: true,
        node: <Trans>Sign out</Trans>,
        onClick: onClickSignOut,
      },
    ],
  };

  // FIXME We are using the old Avatar here when the new Avatar is merged we need to refator it.
  return (
    <UserNavItem>
      <ProfileAvatar
        size='small'
        src={clientStore?.signedInProfile.avatar?.url}
        name={clientStore?.signedInProfile.fullName}
        // negativeVersion={props.isDark}
        onClick={() => headerStore?.ToggleUserDropdown()}
      />
      {isMobile ? (
        <MobileUserNav
          show={props.show}
          onClickParent={() => headerStore?.HideUserDropdown()}
          {...headerAvatarMenuConfig}
        />
      ) : (
        <Dropdown
          userMenu
          isVisible={props.show}
          onMouseLeave={() => headerStore?.HideUserDropdown()}
        >
          <DropdownTitle>{headerAvatarMenuConfig.title}</DropdownTitle>
          <DropdownSeparator />
          {headerAvatarMenuConfig.list.map((obj, index) => (
            <DropdownItem
              key={index}
              danger={obj?.danger}
              onClick={obj?.onClick}
            >
              {obj?.node}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </UserNavItem>
  );
});

HeaderAvatar.defaultProps = {
  show: false,
  isMobile: false,
};

HeaderAvatar.propTypes = {
  show: PropTypes.bool,
  isMobile: PropTypes.bool,
  isDark: PropTypes.bool,
  headerStore: PropTypes.object,
  clientStore: PropTypes.object,
};

export default withNamespaces()(HeaderAvatar);
